import { setRoute } from '../../routes/actions/set';

export function request(id) {
    id = parseInt(id, 10);

    return (dispatch, getState) => {
        const state = getState();

        if (id == state.routes.getIn([ 'customers', 'value' ])) {
            dispatch(setRoute('customers'));
        }

        dispatch({
            type: 'CUSTOMERS_SAVE_HISTORY_REQUEST',
            id
        });

        dispatch({
            type: 'CUSTOMERS_CLOSE_REQUEST',
            id
        });

    };
}
